"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKDataGridLegacyCollapseExampleCodeSegments = exports.GKDataLegacyCollapseExample = void 0;
var gds_ux_components_1 = require("@granular/gds-ux-components");
var React = __importStar(require("react"));
var __1 = require("../..");
// <copy>
var getData = function () {
    return __spreadArray([], Array(5), true).map(function (d, i) { return ({
        name: "Item " + i,
        randCell: Math.round(Math.random() * 100),
    }); });
};
var GKDataLegacyCollapseExample = function () {
    var _a = React.useState(getData()), data = _a[0], setData = _a[1];
    var _b = React.useState(true), collapse = _b[0], setCollapse = _b[1];
    return (React.createElement(React.Fragment, null,
        React.createElement(gds_ux_components_1.GKCheckbox, { label: "Collapse on data change", checked: collapse, onChange: function () { return setCollapse(!collapse); } }),
        React.createElement(__1.GKDataGridLegacy, { columns: [
                {
                    accessor: "name",
                    Header: "Name",
                },
                {
                    accessor: "randCell",
                    Header: "Random Number",
                },
            ], data: data, expandable: true, collapseOnDataChange: collapse, SubComponent: function () { return (React.createElement("div", { className: "d-flex p-3" },
                React.createElement(gds_ux_components_1.GKButton, { className: "m-auto", onClick: function () { return setData(getData()); } }, "Change the Data"))); } })));
};
exports.GKDataLegacyCollapseExample = GKDataLegacyCollapseExample;
// </copy>
// AUTOGENERATED:
/* eslint-disable prettier/prettier */
exports.GKDataGridLegacyCollapseExampleCodeSegments = ["const getData = (): {\n  name: string;\n  randCell: number;\n}[] =>\n  [...Array(5)].map((d, i) => ({\n    name: \"Item \" + i,\n    randCell: Math.round(Math.random() * 100),\n  }));\nexport const GKDataLegacyCollapseExample: React.FC = () => {\n  const [data, setData] = React.useState(getData());\n  const [collapse, setCollapse] = React.useState(true);\n  return (\n    <>\n      <GKCheckbox\n        label=\"Collapse on data change\"\n        checked={collapse}\n        onChange={(): void => setCollapse(!collapse)}\n      />\n      <GKDataGridLegacy\n        columns={[\n          {\n            accessor: \"name\",\n            Header: \"Name\",\n          },\n          {\n            accessor: \"randCell\",\n            Header: \"Random Number\",\n          },\n        ]}\n        data={data}\n        expandable={true}\n        collapseOnDataChange={collapse}\n        SubComponent={(): JSX.Element => (\n          <div className=\"d-flex p-3\">\n            <GKButton\n              className=\"m-auto\"\n              onClick={(): void => setData(getData())}\n            >\n              Change the Data\n            </GKButton>\n          </div>\n        )}\n      />\n    </>\n  );\n};"];
/* eslint-enable prettier/prettier */
